"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRANDS_BY_SUBJECT = void 0;
exports.getStrandLabel = getStrandLabel;
exports.isValidStrand = isValidStrand;
const ENGLISH_STRANDS = [
    {
        id: 'handwriting',
        label: 'Handwriting',
    },
    {
        id: 'spelling',
        label: 'Spelling',
        labelByStage: {
            EYFS: 'Letters & Sounds',
            KS1: 'Phonics & Spelling',
            KS2: 'Spelling',
        },
    },
    {
        id: 'grammar_punctuation',
        label: 'Grammar & Punctuation',
        labelByStage: {
            EYFS: 'Sentence Basics',
            KS1: 'Grammar & Punctuation',
            KS2: 'Grammar & Punctuation (SPaG)',
        },
    },
    {
        id: 'reading',
        label: 'Reading & Comprehension',
    },
    {
        id: 'composition',
        label: 'Writing (Composition)',
        labelByStage: {
            EYFS: 'Early Writing',
            KS1: 'Writing',
            KS2: 'Writing (Composition)',
        },
    },
];
const MATHS_STRANDS = [
    { id: 'number_place_value', label: 'Number & Place Value' },
    { id: 'arithmetic', label: 'Arithmetic' },
    { id: 'fractions', label: 'Fractions, Decimals & Percentages' },
    { id: 'measurement', label: 'Measurement' },
    { id: 'geometry', label: 'Geometry — Properties of Shape' },
    { id: 'position_direction', label: 'Geometry — Position & Direction' },
    { id: 'statistics', label: 'Statistics' },
    { id: 'ratio_proportion', label: 'Ratio & Proportion' },
    { id: 'algebra', label: 'Algebra' },
];
const SCIENCE_STRANDS = [
    { id: 'biology', label: 'Biology (Living Things)' },
    { id: 'chemistry', label: 'Chemistry (Materials)' },
    { id: 'physics', label: 'Physics (Forces, Light, Sound, Electricity)' },
    { id: 'working_scientifically', label: 'Working Scientifically' },
];
const COMPUTING_STRANDS = [
    { id: 'computer_science', label: 'Computer Science' },
    { id: 'information_technology', label: 'Information Technology' },
    { id: 'digital_literacy', label: 'Digital Literacy & Online Safety' },
];
const PSHE_STRANDS = [
    { id: 'health_wellbeing', label: 'Health & Wellbeing' },
    { id: 'relationships', label: 'Relationships' },
    { id: 'living_in_wider_world', label: 'Living in the Wider World' },
];
const HISTORY_STRANDS = [
    { id: 'chronology', label: 'Chronology' },
    { id: 'knowledge_events', label: 'Knowledge of Events & People' },
    { id: 'interpretation', label: 'Historical Interpretation' },
];
const GEOGRAPHY_STRANDS = [
    { id: 'location_knowledge', label: 'Location Knowledge' },
    { id: 'place_knowledge', label: 'Place Knowledge' },
    { id: 'human_physical', label: 'Human & Physical Geography' },
    { id: 'skills_fieldwork', label: 'Skills & Fieldwork' },
];
const RE_STRANDS = [
    { id: 'beliefs_practices', label: 'Beliefs & Practices' },
    { id: 'expressing_meaning', label: 'Expressing Meaning' },
    { id: 'values_commitments', label: 'Values & Commitments' },
];
const ART_STRANDS = [
    { id: 'drawing_painting', label: 'Drawing & Painting' },
    { id: 'sculpture_textiles', label: 'Sculpture & Textiles' },
    { id: 'digital_art', label: 'Digital Art' },
    { id: 'artists_movements', label: 'Artists & Movements' },
];
const DT_STRANDS = [
    { id: 'design', label: 'Design' },
    { id: 'make', label: 'Make' },
    { id: 'evaluate', label: 'Evaluate' },
    { id: 'technical_knowledge', label: 'Technical Knowledge' },
    { id: 'cooking_nutrition', label: 'Cooking & Nutrition' },
];
const MUSIC_STRANDS = [
    { id: 'listen', label: 'Listen & Appraise' },
    { id: 'perform', label: 'Perform' },
    { id: 'compose', label: 'Compose' },
    { id: 'notation', label: 'Notation' },
];
const PE_STRANDS = [
    { id: 'fundamentals', label: 'Fundamental Movement Skills' },
    { id: 'games', label: 'Games' },
    { id: 'dance', label: 'Dance' },
    { id: 'gymnastics', label: 'Gymnastics' },
    { id: 'athletics', label: 'Athletics' },
    { id: 'outdoor_adventurous', label: 'Outdoor & Adventurous' },
    { id: 'swimming', label: 'Swimming & Water Safety' },
];
const MFL_STRANDS = [
    { id: 'listen', label: 'Listening' },
    { id: 'speak', label: 'Speaking' },
    { id: 'read', label: 'Reading' },
    { id: 'write', label: 'Writing' },
    { id: 'grammar', label: 'Grammar' },
];
exports.STRANDS_BY_SUBJECT = {
    english: ENGLISH_STRANDS,
    maths: MATHS_STRANDS,
    science: SCIENCE_STRANDS,
    computing: COMPUTING_STRANDS,
    pshe: PSHE_STRANDS,
    history: HISTORY_STRANDS,
    geography: GEOGRAPHY_STRANDS,
    re: RE_STRANDS,
    art_design: ART_STRANDS,
    design_technology: DT_STRANDS,
    music: MUSIC_STRANDS,
    pe: PE_STRANDS,
    mfl: MFL_STRANDS,
};
function getStrandLabel(subject, strandId, keyStage) {
    const strand = exports.STRANDS_BY_SUBJECT[subject].find((s) => s.id === strandId);
    if (!strand)
        return strandId;
    if (keyStage && strand.labelByStage?.[keyStage]) {
        return strand.labelByStage[keyStage];
    }
    return strand.label;
}
function isValidStrand(subject, strandId) {
    return exports.STRANDS_BY_SUBJECT[subject].some((s) => s.id === strandId);
}
